import { render, staticRenderFns } from "./ExamQuestionPaperSettings.vue?vue&type=template&id=2f6ed263"
import script from "./ExamQuestionPaperSettings.vue?vue&type=script&lang=js"
export * from "./ExamQuestionPaperSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports